export default {
	setProjects(state, projects) {
		state.projects = projects
	},
}
